module.exports = __webpack_public_path__ + "img/pixel-cookie.f4d456bd.gif";